import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}

export const getValidarPagarDocumento = async (
  rut: number | null
): Promise<boolean> => {
  try {
    const res = await apiClient.post<ApiResponse<boolean>>(
      Endpoints.PagoValidarDocumento,
      {
        rut: `${rut}`,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
